const DEFAULT_CONFIG = {
  PaymentTerm: {
    renderedField: "name",
    fieldView: ["name"],
    searchField: ["name"],
  },
  Employee: {
    renderedField: "fullName",
    fieldView: ["fullName", "employeeId"],
    searchField: ["fullName"],
  },
  EmployeeGroup: {
    renderedField: "name",
    fieldView: ["name"],
    searchField: ["name"],
  },
  EmployeeGrade: {
    renderedField: "name",
    fieldView: ["name"],
    searchField: ["name"],
  },
  Company: {
    renderedField: "name",
    fieldView: ["name"],
    searchField: ["name"],
  },
  Branch: {
    renderedField: "name",
    fieldView: ["name"],
    searchField: ["name"],
  },
  _Role: {
    renderedField: "name",
    fieldView: ["name"],
    searchField: ["name"],
  },
  Lead: {
    renderedField: "leadId",
    fieldView: ["leadId", "name"],
    searchField: ["leadId"],
  },
  Customer: {
    renderedField: "code",
    fieldView: ["code", "fullName"],
    searchField: ["code"],
  },
  CustomerByPhone: {
    renderedField: "phone",
    fieldView: ["phone"],
    // models: ["_User"],
    searchField: ["phone"],
  },
  CustomerByName: {
    renderedField: "fullName",
    fieldView: ["fullName"],
    searchField: ["fullName"],
  },
  Campaign: {
    renderedField: "name",
    fieldView: ["name"],
    searchField: ["name"],
  },
  Category: {
    renderedField: "name",
    fieldView: ["name"],
    searchField: ["name"],
  },
  Brand: {
    renderedField: "name",
    fieldView: ["name"],
    searchField: ["name"],
  },
  Product: {
    renderedField: "name",
    searchField: ["name", "barcode"],
    fieldView: ["name", "barcode"],
  },
  ProductByBarcode: {
    renderedField: "barcode",
    searchField: ["name", "barcode"],
    fieldView: ["name", "barcode"],
  },
  ProductVariance: {
    renderedField: "barcode",
    searchField: [
      "barcode",
      "color",
      "size",
      "totalWeight",
      "goldWeight",
      "stoneWeight",
    ],
    fieldView: ["name", "barcode"],
  },
  WareHouse: {
    renderedField: "name",
    searchField: ["name", "code"],
    fieldView: ["name", "code"],
  },
  Department: {
    renderedField: "name",
    fieldView: ["name"],
    searchField: ["name"],
  },
  Vendor: {
    renderedField: "name",
    fieldView: ["name"],
    searchField: ["name"],
  },
  EmployeeMember: {
    renderedField: "employeeId",
    fieldView: ["employeeId", "fullName"],
    searchField: ["employeeId"],
  },
  Kpi: {
    renderedField: "name",
    fieldView: ["name"],
    searchField: ["name"],
  },
  CustomerMember: {
    renderedField: "code",
    fieldView: ["code", "fullName"],
    searchField: ["code"],
  },
  CustomerGroup: {
    renderedField: "name",
    fieldView: ["name"],
    searchField: ["name"],
  },
};
export default DEFAULT_CONFIG;
